<template></template>

<script>

import Vuex from 'vuex'

import Storage from '@/helpers/storage'

import I18n from '@/modules/i18n'
import Partners from '@/modules/partners'

export default {

    name: 'metas',

    computed: {

        ...Vuex.mapGetters(['lang', 'page'])

    },

    // update metas when page or lang are updated
    watch: {

        lang: function () {

            this.updateMetas()

        },

        page: function () {

            this.updateMetas()

        }

    },

    data() {
        return {

            landing: {
                canonical: 'https://www.cleanfox.io',
                pages: ['landing_web', 'landing_web_magic']
            },

            login: {
                canonical: 'https://www.cleanfox.io/login',
                pages: ['login', 'login_google_tuto_web', 'login_yahoo_tuto_web', 'login_icloud_tuto_web', 'login_provider_tuto_web_seo_title']
            }

        }
    },

    mounted() {

        this.updateMetas()

    },

    methods: {


        async updateMetas() {

            const page = this.convertPage(this.page)

            const titleNotExist = !document.querySelector('title')

            const metaNotExist = !document.querySelector('meta[name="description"]')

            const keywordsNotExist = !document.querySelector('meta[name="keywords"]')

            if (titleNotExist) {

                const title = document.createElement('title')
                document.getElementsByTagName('head')[0].appendChild(title)

            }

            if (metaNotExist) {

                const meta = document.createElement('meta')
                meta.name = 'description'
                document.getElementsByTagName('head')[0].appendChild(meta)

            }

            if (keywordsNotExist) {

                const meta = document.createElement('meta')
                meta.name = 'keywords'
                document.getElementsByTagName('head')[0].appendChild(meta)

            }

            // always title before meta description
            document.querySelector('title').text = await this.getTitle(page) || ''

            // content beetween 70 and 160 characters
            document.querySelector('meta[name="description"]').content = await this.getDescription(page)

            // keywords
            document.querySelector('meta[name="keywords"]').content = this.getKeywords(page)


            this.canonical(page)


            if (Storage.getItem('debugMeta')) {

                this.debugMeta(page)

            }

        },


        async getTitle(page) {

            if (page.indexOf('partner_') > -1) {

                return await this.getPartnerSeo(page, 'title') || this.$t(`landing_web_seo_title`)

            }

            return this.$te(`${page}_seo_title`) ? this.$t(`${page}_seo_title`) : ''

        },

        async getDescription(page) {

            if (page.indexOf('partner_') > -1) {

                return await this.getPartnerSeo(page, 'description') || this.$t(`landing_web_seo_description`)

            }

            return this.$te(`${page}_seo_description`) ? this.$t(`${page}_seo_description`) : ''

        },

        async getPartnerSeo(page, key) {

            const partner = page.split('_')[1]

            return await Partners.getSeo(partner, I18n.get(this))
                .then(seo => {

                    return seo[key]

                })
                .catch(() => {
                    return false
                })
        },

        getKeywords(page) {

            return this.$te(`${page}_seo_keywords`) ? this.$t(`${page}_seo_keywords`) : ''

        },

        canonical(page) {
            // <link rel="canonical" href="https://www.cleanfox.io" />

            if (document.querySelector('link[rel="canonical"]')) {
                document.querySelector('link[rel="canonical"]').remove()
            }

            const isLanding = this.landing.pages.indexOf(page) > -1
            const isLogin = this.login.pages.indexOf(page) > -1

            if (isLanding || isLogin) {

                const canonical = document.createElement('link')
                canonical.rel = 'canonical'
                canonical.href = isLanding ? this.landing.canonical : this.login.canonical
                document.getElementsByTagName('head')[0].appendChild(canonical)

            }

        },

        convertPage(page) {

            if (page === 'login_google_tuto_web' || page === 'login_yahoo_tuto_web' || page === 'login_icloud_tuto_web' || page === 'login_outlook_tuto_web') {

                return 'login_provider_tuto_web'
            }

            if (page === 'cleaning_cards') {

                return 'cleaning_list'
            }

            if (page === 'stats') {

                return 'statistics'
            }

            if (page === 'my-data') {

                return 'your_data'
            }

            return page

        },

        debugMeta(page) {

            if (page) {

                const title = document.querySelector('title').text
                const metaDescription = document.querySelector('meta[name="description"]').content

                console.debug('page = ', page)
                console.debug('title: ', title)
                console.debug('metaDescription: ', metaDescription)

            }

        }

    }

}

</script>

<style lang="scss" scoped></style>
